import { icons } from 'src/assets/iconDef/icon.def';

export const dietKitchenMenuDef = [
  
  {
    "name": "menu.diet_order_stage",
    "resource": "diet_plan_format",
    "view": "diet_plan_format",
    "icon": "fa fa-tag",
    "url": "diet_plan_format",
    "breadcrumb": "diet_plan_format",
    "auto_crud": true,
    "showMenu": true
  },
  {
    "name": "menu.kitchen_order_stages",
    "resource": "kitchen_plan_format",
    "view": "kitchen_plan_format",
    "icon": "fa fa-tag",
    "url": "kitchen_plan_format",
    "breadcrumb": "Kitchen Plan",
    "auto_crud": true,
    "showMenu": true
  },
  {
    "name": "menu.kitchen_order_stages",
    "resource": "diet_ward_summary",
    "view": "diet_ward_summary",
    "icon": "fa fa-tag",
    "url": "diet_ward_summary",
    "breadcrumb": "Kitchen Plan",
    "auto_crud": true,
    "showMenu": true
  },
  {
    "name": "Diet Order stages",
    "resource": "dietOrder_planned_grid",
    "view": "dietOrder_planned_grid",
    "icon": "fa fa-tag",
    "url": "dietOrder_planned_grid",
    "breadcrumb": "dietOrder_planned_grid",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Diet Order stages",
    "resource": "diet_plan",
    "view": "diet_plan",
    "icon": "fa fa-tag",
    "url": "diet_plan",
    "breadcrumb": "diet_plan",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Diet Order stages",
    "resource": "dietOrder_acknowledge",
    "view": "dietOrder_acknowledge",
    "icon": "fa fa-tag",
    "url": "dietOrder_acknowledge",
    "breadcrumb": "dietOrder_acknowledge",
    "auto_crud": true,
    "showMenu": false
  },
  {
    name: 'dietician_bed_transferHistory',
    resource: 'dietician_bed_transferHistory',
    icon: 'fa fa-h-square',
    url: 'dietician_bed_transferHistory',
    auto_crud: true,
    showMenu: false
},
  {
    "name": "Diet Order stages",
    "resource": "dietOrder_pending",
    "view": "dietOrder_pending",
    "icon": "fa fa-tag",
    "url": "dietOrder_pending",
    "breadcrumb": "dietOrder_pending",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Diet Order stages",
    "resource": "alaCarte_pending",
    "view": "alaCarte_pending",
    "icon": "fa fa-tag",
    "url": "alaCarte_pending",
    "breadcrumb": "alaCarte_pending",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Diet Order stages",
    "resource": "alaCarte_acknowledge",
    "view": "alaCarte_acknowledge",
    "icon": "fa fa-tag",
    "url": "alaCarte_acknowledge",
    "breadcrumb": "alaCarte_acknowledge",
    "auto_crud": true,
    "showMenu": false
  },

  
  {
    "name": "menu.diet_planning",
    "resource": "kitchenOrder_pending",
    "view": "kitchenOrder_pending",
    "icon": "fa fa-tag",
    "url": "kitchenOrder_pending",
    "breadcrumb": "Kitchen  Plan",
    "auto_crud": true,
    "showMenu":false
  },
  {
    "name": "menu.kitchenOrder_acknowledge",
    "resource": "kitchenOrder_acknowledge",
    "view": "kitchenOrder_acknowledge",
    "icon": "fa fa-tag",
    "url": "kitchenOrder_acknowledge",
    "breadcrumb": "Kitchen  Plan",
    "auto_crud": true,
    "showMenu":false
  },
  {
    "name": "menu.kitchenOrder_dispatch",
    "resource": "kitchenOrder_dispatch",
    "view": "kitchenOrder_dispatch",
    "icon": "fa fa-tag",
    "url": "kitchenOrder_dispatch",
    "breadcrumb": "Kitchen  Plan",
    "auto_crud": true,
    "showMenu":false
  },
  {
    "name": "menu.kitchenAlaCarte_pending",
    "resource": "kitchenAlaCarte_pending",
    "view": "kitchenAlaCarte_pending",
    "icon": "fa fa-tag",
    "url": "kitchenAlaCarte_pending",
    "breadcrumb": "Kitchen  Plan",
    "auto_crud": true,
    "showMenu":false
  },
  {
    "name": "menu.kitchenAlaCarte_acknowledge",
    "resource": "kitchenAlaCarte_acknowledge",
    "view": "kitchenAlaCarte_acknowledge",
    "icon": "fa fa-tag",
    "url": "kitchenAlaCarte_acknowledge",
    "breadcrumb": "Kitchen  Plan",
    "auto_crud": true,
    "showMenu":false
  },
  {
    "name": "menu.kitchenAlaCarte_dispatch",
    "resource": "kitchenAlaCarte_dispatch",
    "view": "kitchenAlaCarte_dispatch",
    "icon": "fa fa-tag",
    "url": "kitchenAlaCarte_dispatch",
    "breadcrumb": "Kitchen  Plan",
    "auto_crud": true,
    "showMenu":false
  },
  {
    "name": "menu.meal_card",
    "resource": "meal_card",
    "view": "meal_card",
    "icon": "fa fa-tag",
    "url": "meal_card",
    "breadcrumb": "meal_card",
    "auto_crud": true,
    "showMenu":true
  },
  {
    "name": "plan_details",
    "resource": "plan_details",
    "view": "plan_details",
    "icon": "fa fa-tag",
    "url": "plan_details",
    "breadcrumb": "Plan details",
    "auto_crud": true,
    "showMenu":false
  },
  {
    "name": "plan_details_rtFeed",
    "resource": "plan_details_rtFeed",
    "view": "plan_details_rtFeed",
    "icon": "fa fa-tag",
    "url": "plan_details_rtFeed",
    "breadcrumb": "Plan details",
    "auto_crud": true,
    "showMenu":false
  },
  {
    "name": "plan_details_liquid",
    "resource": "plan_details_liquid",
    "view": "plan_details_liquid",
    "icon": "fa fa-tag",
    "url": "plan_details_liquid",
    "breadcrumb": "Plan details",
    "auto_crud": true,
    "showMenu":false
  },
  {
    "name": "menu.summary",
    "resource": "summary",
    "view": "summary",
    "icon": "fa fa-tag",
    "url": "summary",
    "breadcrumb": "summary",
    "auto_crud": true,
    "showMenu":true
  },
  {
    "name": "diet_dischargeInitiatedPatients",
    "resource": "diet_dischargeInitiatedPatients",
    "view": "diet_dischargeInitiatedPatients",
    "icon": "fa fa-tag",
    "url": "diet_dischargeInitiatedPatients",
    "breadcrumb": "diet_dischargeInitiatedPatients",
    "auto_crud": true,
    "showMenu":false
  },
  {
    "name": "diet_dischargedPatients",
    "resource": "diet_dischargedPatients",
    "view": "diet_dischargedPatients",
    "icon": "fa fa-tag",
    "url": "diet_dischargedPatients",
    "breadcrumb": "diet_dischargedPatients",
    "auto_crud": true,
    "showMenu":false
  },
  {
    "name": "diet_planDefinition",
    "resource": "diet_planDefinition",
    "url": "diet_planDefinition",
    "auto_crud": true
  },
  {
    "name": "meal_order",
    "resource": "meal_order",
    "url": "meal_order",
    "auto_crud": true
  },
  {
    "name": "view_diet_orders",
    "resource": "view_diet_orders",
    "url": "view_diet_orders",
    "auto_crud": true
  },
  {
    "name": "dietician_worklist",
    "resource": "dietician_worklist",
    "url": "dietician_worklist",
    "auto_crud": true
  },
  {
    "name": "kitchen_ward_mis",
    "resource": "kitchen_ward_mis",
    "url": "kitchen_ward_mis",
    "auto_crud": true
  },
  {
    "name": "mis_diet_bill_summary",
    "resource": "mis_diet_bill_summary",
    "url": "mis_diet_bill_summary",
    "auto_crud": true
  },
  {
    "name": "inactive_dietician_worklist",
    "resource": "inactive_dietician_worklist",
    "url": "inactive_dietician_worklist",
    "auto_crud": true
  },
  {
    "name": "dietician_worklist_format",
    "resource": "dietician_worklist_format",
    "url": "dietician_worklist_format",
    "auto_crud": true
  },
  {
    "name": "new_admission",
    "resource": "new_admission",
    "url": "new_admission",
    "auto_crud": true
  },
  {
    "name": "diet_plan_changed",
    "resource": "diet_plan_changed",
    "url": "diet_plan_changed",
    "auto_crud": true
  },
  {
    "name": "cancel_diet_order",
    "resource": "cancel_diet_order",
    "url": "cancel_diet_order",
    "auto_crud": true
  },
  {
    "name":"acknowledge_diet_order",
    "resource":"acknowledge_order",
    "url":"acknowledge_order",
    "auto_crud":true
  },
  {
    "name":"diet_dispatch_report",
    "resource":"diet_dispatch_report",
    "url":"diet_dispatch_report",
    "auto_crud":true
  },
  {
    "name":"acknowledge_alacarte_order",
    "resource":"acknowledge_alacarte_order",
    "url":"acknowledge_alacarte_order",
    "auto_crud":true
  },
]
